import { createRoot } from 'react-dom/client';
import styled from 'styled-components';

const Root = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  > div {
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    width: fit-content;
    max-width: -webkit-fill-available !important;
  }
`;

class CustomLabelsRenderer {
  element;

  constructor(props: any) {
    const data = props.value;
    this.element = document.createElement('div');
    const root = createRoot(this.element);

    root.render(
      <Root>
        {data?.name1 && <div className='text-center badge text_tertiary'>{data?.name1}</div>}
        <div className={`text-center badge ${data?.color1 || 'text_tertiary'}`}>{data?.name2 || '미분류'}</div>
      </Root>
    );
  }

  getElement() {
    return this.element;
  }
}
export default CustomLabelsRenderer;
